import Tabs3 from './Tabs3';
import './Tabs3.scss';

export default Tabs3;
